import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const oauthApplicationsAccessControl: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.oauthApplications],
  permissions: [Permission.RetailerCredentialManagementView],
}

export const oauthApplicationsModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RetailerCredentialManagementModify],
}
